import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const StyledComponent = styled(({css, ...rest}) => <code {...rest} />)`
  display: block;
  margin-top: ${p => p.theme.m};
  border: ${p => p.theme.border_line};
  border-color: rgba(167,0,0,0.89);
  padding: ${p => p.theme.xs};

  ${p => p.css}
  &:before {
    content: 'JS Error Stack';
    display: block;
    font-size: 1.42em;
  }
`

const _ErrorStack = (props) => <StyledComponent {...props} />
_ErrorStack.propTypes = {
  css: PropTypes.string,
}

export default _ErrorStack

